import { Boolean, Null, Number, Optional, Record, Static, String, Union, Unknown } from 'runtypes';

import { ResultDirectionEnum as _ResultDirection } from 'src/models/activity/enums';
import { ArchivButtonRunType } from 'src/models/archiv';
import { createEnumGuard } from 'src/models/enumGuard';
import { GlobalizationButtonRunType } from 'src/models/globalization';
import { IdoButtonRunType } from 'src/models/ido';
import { ModuleNameRunType } from 'src/models/module';
import { SpoingButtonRunType } from 'src/models/spoing';
import { StatusButtonRunType } from 'src/models/status';
import { TaskButtonRunType } from 'src/models/task';
import { GroupedStatusRunType, TaskListExtrasRunType } from 'src/models/taskList/extras';

const ResultDirectionRunType = createEnumGuard(Object.values(_ResultDirection) as _ResultDirection[]);

export const TaskListItemRunType = Record({
	accessRight: Boolean,
	aggregateId: String,
	aggregateVersion: Number,
	archivButton: ArchivButtonRunType,
	archived: Boolean,
	channel: String.Or(Null),
	channelQTip: Null,
	contact: String.Or(Null),
	contactPicture: String.Or(Null),
	contactQTip: String.Or(Null),
	context: String.Or(Null),
	contextQTip: String.Or(Null),
	date: String,
	directAccessUser: String.Or(Null),
	direction: ResultDirectionRunType,
	directionQTip: Null,
	extras: TaskListExtrasRunType,
	globalizationButton: GlobalizationButtonRunType,
	globalized: Boolean,
	groupedStatus: GroupedStatusRunType,
	idoButton: IdoButtonRunType,
	idoLinked: Boolean,
	information: String.Or(Null),
	informationQTip: String.Or(Null),
	moduleName: ModuleNameRunType,
	moduleSort: Number.Or(Null),
	processId: String,
	spoingButton: Union(SpoingButtonRunType).Or(Record({})),
	status: Number,
	statusButton: StatusButtonRunType,
	taskButton: Optional(TaskButtonRunType).Or(Null).Or(Unknown),
	timeFrame: Number,
	timestamp: Number,
});

export type TaskListItem = Static<typeof TaskListItemRunType>;
